module.exports = __webpack_public_path__ + "static/media/signage-indoor-img68.3e15baac.jpg";